module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-fleet-position"
  }, _vm._l((_vm.value), function(elem, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('DeleteConf', {
      on: {
        "click": function($event) {
          return _vm.value.splice(index, 1)
        }
      }
    }), _vm._l((elem), function(val, inx, key) {
      return _c('div', {
        staticClass: "column"
      }, [(inx === 'vehicle_category_id') ? _c('SelectizeCategory', {
        on: {
          "optionSelected": function($event) {
            return _vm.updateCategory($event, key)
          }
        },
        model: {
          value: (_vm.value[index][inx]),
          callback: function($$v) {
            _vm.$set(_vm.value[index], inx, $$v)
          },
          expression: "value[index][inx]"
        }
      }) : _vm._e(), (inx === 'booking_mode') ? _c('BookingModeSelect', {
        model: {
          value: (_vm.value[index][inx]),
          callback: function($$v) {
            _vm.$set(_vm.value[index], inx, $$v)
          },
          expression: "value[index][inx]"
        }
      }) : _vm._e()], 1)
    })], 2)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-05311f62!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/configuration/FleetPositionConfiguration.vue
// module id = 2230
// module chunks = 1